import React, { useRef, useState, useEffect } from "react";
import { Banner } from "./Banner";
import { CartSummary } from "./CartSummary";
import { ContentBottom } from "./ContentBottom";
import { Card } from "./ContentCard";
import { FAQs } from "./FAQs";
import "./MyStyles/style.css";
import "./MyStyles/responsive.css";
import { Skeleton, Stack } from "@mui/material";
import { showtoast } from "./Utilities/Utilities";
import { LeadSubmitDetails } from "./Utilities/LeadSubmitDetails";
import { LeadSuccessModal } from "./Utilities/LeadSuccessModal";
import { validateMobile } from "./Utilities/InputValidations";
import { mySweetAlert } from "./Utilities/Utilities";

//const colorClasses = ["cardBorder-default","cardBorder-yellow", "cardBorder-blue", "cardBorder-orange", "cardBorder-green"]; // Array of color classes
const BGClasses = [
  "BG-default",
  "BG-yellow",
  "BG-blue",
  "BG-orange",
  "BG-green",
]; // Array of color classes

const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;

export const ContentMain = ({ data, isTokenValid, reqParams }) => {
  const planRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [allCartSummary, setAllCartSummary] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [leadBuyerInfo, setLeadBuyerInfo] = useState({
    BuyerName: "",
    MobileNo: "",
  });

  const handleAddToCart = (e, planSummary, buttonName) => {
    e.preventDefault();
    //console.log(planSummary, allCartSummary);
    let totalVoucher = 0;
    if (planSummary) {
      let MyCartSummary = [...allCartSummary];
      const index = MyCartSummary.findIndex(
        (item) => item.planID === planSummary.planID,
      );

      if (index !== -1) {
        if (planSummary.voucherCount > 0) {
          MyCartSummary[index] = {
            ...MyCartSummary[index],
            quantity: planSummary.voucherCount,
          };
        } else {
          let updatedCartSummary = allCartSummary.filter(
            (item) => item.planID !== planSummary.planID,
          );
          MyCartSummary = MyCartSummary.filter(
            (item) => item.planID !== planSummary.planID,
          );

          setAllCartSummary(updatedCartSummary);
        }
      } else {
        if (planSummary.voucherCount > 0) {
          MyCartSummary.push({
            planID: planSummary.planID,
            subscriptionPlanName: planSummary.planName,
            subscriptionAmount: planSummary.planPrice,
            quantity: planSummary.voucherCount,
          });
        }
      }

      if (MyCartSummary.length > 0) {
        MyCartSummary.forEach((data) => {
          totalVoucher += data.quantity;
        });
      }

      if (totalVoucher > 25) {
        //showtoast("error", "Maximum 25 vouchers are allowed.");
        setIsModalVisible(true);

        return;
      }

      if (MyCartSummary && MyCartSummary.length > 0) {
        getBulkPurchaseDiscountedPrice(planSummary, MyCartSummary);
        setIsVisible(true);
      }
      if (planSummary && planSummary.voucherCount > 0) {
        buttonName("Update Cart");
      } else {
        buttonName("Add To Cart");
      }

      //else
      //{
      //    let updatedCartSummary = allCartSummary.filter((item) => item.planID !== planSummary.planID)

      //    setAllCartSummary(updatedCartSummary);
      //}
    }
  };

  const handleCloseCartSummary = () => {
    setIsVisible(false);
  };

  const getBulkPurchaseDiscountedPrice = (planSummary, MyCartSummary) => {
    const request =
      MyCartSummary &&
      MyCartSummary.length > 0 &&
      MyCartSummary.map((item) => {
        const data = {
          SubscriptionPlanID: item.planID,
          Quantity: item.quantity,
          PlanAmount: item.subscriptionAmount,
        };
        return data;
      });

    fetch(
      `${apiBaseURL}/api/FriendAndFamily/GetWatchoFFPlanAggregateDiscountInfo`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
      },
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((resultInfo) => {
        console.log("BulkPurchaseDiscount:", resultInfo);

        if (resultInfo && resultInfo.resultStatus === "Success") {
          //resultInfo.result = { ...resultInfo.result, planName: planSummary.planName, PlanID: planSummary.planID }
          //setPlanPriceDetails(resultInfo.result);

          //let MyCartSummary = [...allCartSummary]
          //const index = MyCartSummary.findIndex((item) => item.planID === resultInfo.result.planID);

          //if (index !== -1) {
          //    MyCartSummary[index] = { ...MyCartSummary[index], ...resultInfo.result };
          //} else {
          //    MyCartSummary.push(resultInfo.result);
          //}

          setAllCartSummary(resultInfo.result);

          //console.log(resultInfo.result);
        } else if (resultInfo && resultInfo.resultStatus !== "Success") {
          mySweetAlert("error", resultInfo.resultMessage);
        }
      })
      .catch((err) => {
        console.error("Error calling planPrice API:", err);

        //setError(err);
      });
  };

  // Function to handle the scroll on click
  const handleScrollToPlan = (e) => {
    e.preventDefault();
    setTimeout(
      () =>
        planRef.current?.scrollIntoView({
          behavior: "smooth",
          inline: "center",
        }),
      444,
    );
  };

  const handleLeadSubmit = () => {
    SubmitFAFLeads();
  };

  const SubmitFAFLeads = () => {
    const reqBuyerInfo = {
      ...leadBuyerInfo,
    };

    if (
      reqBuyerInfo.BuyerName !== "" &&
      reqBuyerInfo.BuyerName !== null &&
      reqBuyerInfo.MobileNo &&
      reqBuyerInfo.MobileNo.length === 10 &&
      validateMobile(reqBuyerInfo.MobileNo)
    ) {
      fetch(`${apiBaseURL}/api/FriendAndFamily/SubmitFAFLeads`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(reqBuyerInfo),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((resultInfo) => {
          setIsModalVisible(false);
          if (resultInfo && resultInfo.resultStatus === "Success") {
            // console.log(resultInfo);
            if (resultInfo.resultCode === 0 && resultInfo.result === 1) {
              setSuccessModalVisible(true);
            } else {
              alert("Something went wrong while submitting leads");
            }
          } else if (
            resultInfo &&
            resultInfo.resultStatus === "Failed" &&
            resultInfo.resultCode === -1001
          ) {
            mySweetAlert("error", resultInfo.resultMessage);
          }
        })
        .catch((err) => {
          setIsModalVisible(false);
          console.error("Error while submitting leads:", err);
        })
        .finally(() => {
          if (isTokenValid) {
            setLeadBuyerInfo((prevState) => ({
              ...prevState,
              BuyerName: "",
            }));
          } else {
            setLeadBuyerInfo((prevState) => ({
              BuyerName: "",
              MobileNo: "",
            }));
          }
        });
    } else {
      //alert("Please provide valid input");
      if (reqBuyerInfo.BuyerName === "" || reqBuyerInfo.BuyerName === null) {
        showtoast("error", "Please provide your name.");
      } else if (
        reqBuyerInfo.MobileNo === null ||
        reqBuyerInfo.MobileNo === ""
      ) {
        showtoast("error", "Please provide mobile number.");
      } else if (
        reqBuyerInfo.MobileNo.length !== 10 ||
        !validateMobile(reqBuyerInfo.MobileNo)
      ) {
        showtoast("error", "Please provide valid mobile number.");
      }
    }
  };

  const handleLeadbuyerInfo = (field, e) => {
    let val = e.target.value;
    setLeadBuyerInfo((prevState) => ({
      ...prevState,
      [field]: val,
    }));
  };

  const handleModalVisible = () => {
    setIsModalVisible(false);
  };

  const handleSuccessModalVisible = () => {
    setSuccessModalVisible(false);
  };

  useEffect(() => {
    if (isTokenValid) {
      setLeadBuyerInfo((prevState) => ({
        ...prevState,
        MobileNo: reqParams && reqParams.MobileNo,
      }));
    }
  }, [isTokenValid, reqParams, successModalVisible]);

  return (
    <>
      <div className="contentHeight">
        <Banner />
        <div className="contentMiddle" ref={planRef}>
          {/*<p className="head-middle">Buy More Save more</p>*/}
          {/*<div className="contentTop flex">*/}
          {/*    {data.length > 0 && data.map((dt,idx) => {*/}
          {/*        // Determine the className for this card*/}
          {/*        const bgColorClass = BGClasses[idx % BGClasses.length]; // Cycle through the color classes*/}
          {/*        const cardBorderClass = `cardBorder-${bgColorClass.split('-')[1]}`; // Extract color name for the border className*/}

          {/*        return(*/}
          {/*            <Card key={idx} handleAddToCart={handleShowCartSummary} data={dt} BGColorClass={bgColorClass} cardBorder={cardBorderClass} />*/}
          {/*        )*/}
          {/*    })} */}
          {/*</div>*/}
          <div className="friendsFamily container my-5">
            <h2 className=" heading-bogy  ">Buy more save more</h2>
            <div className="row">
              {data && data.length > 0 ? (
                data.map((dt, idx) => {
                  const bgColorClass = BGClasses[idx % BGClasses.length]; // Cycle through the color classes*/}
                  const cardBorderClass = `cardBorder-${bgColorClass.split("-")[1]}`; // Extract color name for the border className*/ }

                  return (
                    <Card
                      key={idx}
                      handleAddToCart={handleAddToCart}
                      data={dt}
                      BGColorClass={bgColorClass}
                      cardBorder={cardBorderClass}
                    />
                  );
                })
              ) : (
                <>
                  <Stack
                    spacing={{ xs: 1, sm: 2, md: 2 }}
                    direction={{ xs: "column", sm: "column", md: "row" }}
                  >
                    {Array.from({ length: 3 }).map((data, idx) => (
                      <Skeleton
                        key={idx}
                        variant="rounded"
                        width={"33%"}
                        height={250}
                      />
                    ))}
                  </Stack>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="contentBottom">
          <ContentBottom />
          <FAQs />
          {/*<p className="back-to-plan" onClick={handleScrollToPlan}>Back to plan</p>*/}

          <div
            className="text-center back-to mb-5"
            onClick={handleScrollToPlan}
          >
            {" "}
            Back to plans{" "}
          </div>
          {isVisible && allCartSummary && allCartSummary.length > 0 && (
            <CartSummary
              handleCloseCartSummary={handleCloseCartSummary}
              allCartSummary={allCartSummary}
              isTokenValid={isTokenValid}
              reqParams={reqParams}
            />
          )}
        </div>
      </div>

      {isModalVisible && (
        <LeadSubmitDetails
          handleLeadbuyerInfo={handleLeadbuyerInfo}
          leadBuyerInfo={leadBuyerInfo}
          handleLeadSubmit={handleLeadSubmit}
          handleModalVisible={handleModalVisible}
        />
      )}
      {successModalVisible && (
        <LeadSuccessModal
          handleSuccessModalVisible={handleSuccessModalVisible}
        />
      )}
    </>
  );
};
